// @TODO remove after merging cba-797
// In favor of RELOAD_AMOUNTS label/value pair
export const PREPAID_RELOAD_AMOUNTS = [500, 1000, 2500, 5000];

export const DEFAULT_RELOAD_AMOUNT = 500;

export const RELOAD_AMOUNTS = [
  {
    label: '$5',
    value: 500
  },
  {
    label: '$10',
    value: 1000
  },
  {
    label: '$25',
    value: 2500
  },
  {
    label: '$50',
    value: 5000
  }
];

export const DEFAULT_AUTO_RELOAD_THRESHOLD = 500;

export const AUTO_RELOAD_THRESHOLDS = [
  {
    label: '$5',
    value: 500
  },
  {
    label: '$10',
    value: 1000
  },
  {
    label: '$25',
    value: 2500
  },
  {
    label: '$50',
    value: 5000
  }
];

export const DEFAULT_AUTO_RELOAD_AMOUNT = 500;

export const AUTO_RELOAD_AMOUNTS = [
  {
    label: '$5',
    value: 500
  },
  {
    label: '$10',
    value: 1000
  },
  {
    label: '$25',
    value: 2500
  },
  {
    label: '$50',
    value: 5000
  }
];
